import { render, staticRenderFns } from "./statisticsArea.vue?vue&type=template&id=f0b75e46&scoped=true&"
import script from "./statisticsArea.vue?vue&type=script&lang=js&"
export * from "./statisticsArea.vue?vue&type=script&lang=js&"
import style0 from "./statisticsArea.vue?vue&type=style&index=0&id=f0b75e46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b75e46",
  null
  
)

export default component.exports